import React, { useEffect, useState } from 'react';
import { Container } from 'reactstrap';
import { Box } from '@mui/material';
import DomainIcon from '@mui/icons-material/Domain';
import HubDetails from './components/HubDetails';
import HubModal from '../AddOrUpdate/components/ModalHub';
import PndApi from '../../../../utils/pnd/PndRestApi';
import SnackbarContent from '@mui/material/SnackbarContent';
import LinearProgress from '@mui/material/LinearProgress';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
import PageHeader from 'src/shared/components/layout/PageHeader';



const HubDetailsIndex = () => {
  useEffect(() => {
    getAllHubDetails();
  }, [])
  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const getAllHubDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllHubDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) { //No Record Found
        setNoRecordFound(true);
      } else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data?.message}`,
        );
        return;

      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };

  const add = () => {
    setTempData(null);
    setViewDetailPopup(true);
    setTitle("Add Hub");
  };
  const edit = async (event) => {
    if (event.hubId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Hub Details")
    }
  }

  return (
    <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
      <Container fluid style={{ maxWidth: '1400px' }}>

        <PageHeader
          icon={<DomainIcon fontSize="large" />}
          title="Hub Management"
          subtitle="View and manage all hub locations and operations."
          gradient="linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)"
        />

        {loading && <LinearProgress sx={{ mb: 2, borderRadius: 2 }} />}

        <Box sx={{ position: 'relative' }}>
          {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) && !isNoRecordFound && <HubDetails reactTableData={reactTableData} onAdd={add} onEdit={edit} />}
          {isNoRecordFound && <HubDetails isNoRecordFound={isNoRecordFound} onAdd={add} onEdit={edit} />}
         
        </Box>

        {viewDetailPopup &&
          <HubModal
            modalShow={viewDetailPopup}
            setModalShow={setViewDetailPopup}
            hubData={temp}
            isTitle={isTitle}
          />}

      </Container>
    </Box>
  );
};

export default HubDetailsIndex;